module.exports = require('node-fetch');